"use client"

import Script from "next/script"
import { useEffect, useRef, useState } from "react"

type Props = {
  commboxId: string
}

export default function CommboxScripts({ commboxId }: Props) {
  const [loaded, setLoaded] = useState(false)
  const initializedRef = useRef(false)

  useEffect(() => {
    if (!loaded) return
    if (initializedRef.current) return

    let tries = 0
    const maxTries = 80 // ~8 seconds at 100ms
    const interval = setInterval(() => {
      tries += 1

      const by = (window as any).BY
      if (by?.contactUs && !initializedRef.current) {
        initializedRef.current = true
        clearInterval(interval)

        by.contactUs({
          baseDomain: "commbox.io/",
          appsSubDomain: "apps",
          streamId: commboxId,
          trackerStreamId: "",
          animateDistance: 0,
          defaultModuleId: 10,
        })
      }

      if (tries >= maxTries) {
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [loaded, commboxId])

  return (
    <Script
      id="commbox-connect"
      src="https://apps.commbox.io/Scripts/connect.js"
      strategy="afterInteractive"
      onLoad={() => setLoaded(true)}
    />
  )
}
